import { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  Button,
  ButtonProps,
  Icon,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { EmployeePermission } from 'src/api/permissions';
import { TooltipWrapper } from 'src/components/TooltipWrapper/TooltipWrapper';
import { adminActions } from 'src/store/admin/slice';
import { getIsDesktop } from 'src/store/agent/selectors';
import { setSidesheetSlots, sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { getUserPermissions } from 'src/store/user/selectors';

import classes from './AdministratorUserPermissions.module.scss';

export type AdministratorUserPermissionsButtonProps = Omit<
  ButtonProps,
  'onClick'
>;

export const AdministratorUserPermissionsButton: FC<
  AdministratorUserPermissionsButtonProps
> = ({ children, ...rest }) => {
  const dispatch = useAppDispatch();
  const isDesktop = useSelector(getIsDesktop);

  const open = useCallback(() => {
    if (isDesktop) {
      dispatch(sidesheetActions.open('permissions'));
    } else {
      dispatch(adminActions.openPermissions());
    }
  }, [dispatch, isDesktop]);

  useEffect(() => {
    dispatch(
      setSidesheetSlots([
        {
          sidesheetId: 'permissions',
          slot: { id: 'tabsLevelModal', mode: 'modal' },
        },
      ]),
    );
  });

  return (
    <TooltipWrapper title='Настройки прав пользователей'>
      <Button
        size='medium'
        data-testid='openUserPermissions'
        onClick={open}
        className={classes.container}
        {...rest}
      >
        {children}
      </Button>
    </TooltipWrapper>
  );
};

export const AdministratorUserPermissions: FC = () => {
  const data = useSelector(getUserPermissions);

  return (
    data?.permissions.has(EmployeePermission.SystemAdmin) && (
      <AdministratorUserPermissionsButton
        startIcon={<Icon iconName={Icons.User} />}
      />
    )
  );
};
